// Utility to detect and control Developer Mode

const DEV_FLAG_STORAGE_KEY = 'splyt_dev_mode';

function readUrlFlag(): boolean | null {
	try {
		if (typeof window === 'undefined') return null;
		const url = new URL(window.location.href);
		const flag = url.searchParams.get('dev');
		if (flag === null) return null;
		return flag === '1' || flag?.toLowerCase() === 'true';
	} catch {
		return null;
	}
}

function readEnvFlag(): boolean {
	try {
		// Vite-style env var
		const raw = (import.meta as any)?.env?.VITE_DEV_MODE;
		if (raw === undefined || raw === null) return false;
		return String(raw) === '1' || String(raw).toLowerCase() === 'true';
	} catch {
		return false;
	}
}

function readStorageFlag(): boolean {
	try {
		if (typeof window === 'undefined') return false;
		const raw = window.localStorage.getItem(DEV_FLAG_STORAGE_KEY);
		if (!raw) return false;
		return raw === '1' || raw.toLowerCase() === 'true';
	} catch {
		return false;
	}
}

export function isDevModeEnabled(): boolean {
	// Priority: URL param > localStorage > env var
	const url = readUrlFlag();
	if (url !== null) return url;
	if (readStorageFlag()) return true;
	return readEnvFlag();
}

export function setDevModeEnabled(enabled: boolean): void {
	try {
		if (typeof window === 'undefined') return;
		window.localStorage.setItem(DEV_FLAG_STORAGE_KEY, enabled ? '1' : '0');
	} catch {
		// ignore
	}
}

export function getDevModeReason(): string {
	const url = readUrlFlag();
	if (url !== null) return 'url-param';
	if (readStorageFlag()) return 'local-storage';
	if (readEnvFlag()) return 'env';
	return 'disabled';
}
















